import { ref } from 'vue'
// import { ElMessageBox } from 'element-plus'
import { useLocalStorage } from '@vueuse/core'
import _ from 'lodash'
const is_need_open_ring = ref(false)
export default function () {
    console.log('>>>>>>>此方法加载')
    const isOpenPlayRing = useLocalStorage('is_open_play_ring', true)
    //必须在播放铃声之前保证有一次交互
    //触发交互
    const clickRing = () => {
        const ringDom = document.querySelector('#ring')
        console.log('>>>>ring交互执行')
        ringDom.pause()
    }
    //播放铃声
    const playRing = _.throttle(async () => {
        const ringDom = document.querySelector('#ring')
        console.log('>>>>铃声播放执行')
        try {
            await ringDom.play()
        } catch (error) {
            console.log('铃声播放error', error)
            if (!is_need_open_ring.value) {
                openRing()
            }
        }
    }, 1500)

    //请求播放权限
    const openRing = () => {
        clickRing()
        is_need_open_ring.value = true
    }

    return {
        isOpenPlayRing,
        clickRing,
        playRing,
    }
}
